import { ContainerImportedRanking } from 'models/ranking/importedRanking/ContainerImportedRanking';

export class ContainerImportedRankingService {
	toModel(ranking) {
		return new ContainerImportedRanking(ranking);
	}
}
